import React, { useEffect } from "react";
import "./MainContent.css";
import yourImage from "../assests/homepage_image.jpg"
import AOS from 'aos';
import 'aos/dist/aos.css';



const MainContent = () => {
  
  // const cards = [
  //   {
  //     title: "Vision",
  //     content: "Our vision is to deliver innovative solutions for space and deep-space systems to keep people safe by advancing scientific discovery."
  //   },
  //   {
  //     title: "Mission",
  //     content: "Our mission is to be a pioneer in microsatellite technology and innovation towards the realization of a new space society."
  //   },
  //   {
  //     title: "Quality Work",
  //     content: "We ensure that all projects are done with utmost professionalism using quality materials while offering clients the support and accessibility."
  //   }
  // ];

  // const projects = [
  //   { image: Project_image_1, title: "PROJECT ORiONß", description: "This vision begins with a small technological innovation to utilize Lower Earth’s orbital environment..." },
  //   { image: Project_image_2, title: "RiGEL UCAV On SWaP Platform​", description: "The nation moves into a new era of defence through unparalleled intelligence, surveillance, and reconnaissance (ISR) capabilities..." },
    
  // ];

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000, // Duration of the animation (in milliseconds)
      easing: 'ease-in-out', // Easing function for the animation
      once: true, // Animation happens only once
    });
  }, []);

  // const industries = [
  //   {
  //     id: 1,
  //     title: "Mission Control Software for CubeSat",
  //     image: "./img/service/single/1.jpg",
  //     link: "service-single-1.html"
  //   },
  //   {
  //     id: 2,
  //     title: "Mission Control Software for UCAV",
  //     image: "./img/service/single/2.jpg",
  //     link: "service-single-2.html"
  //   },
  //   {
  //     id: 3,
  //     title: "Software-Defined Radios for CubeSat Applications",
  //     image: "./img/service/single/3.jpg",
  //     link: "service-single-3.html"
  //   },
  //   {
  //     id: 4,
  //     title: "Agastya : A DNN Robot",
  //     image: "./img/service/single/9.jpg",
  //     link: "service-single-4.html"
  //   }
  // ];

  // const services = [
  //   {
  //     id: "01",
  //     title: "UAV",
  //     description: "Continue indulged speaking the was out horrible for domestic position. Seeing rather her you not esteem men settle genius excuse.",
  //     image: Project_image_3
  //   },
  //   {
  //     id: "02",
  //     title: "ROV",
  //     description: "Continue indulged speaking the was out horrible for domestic position. Seeing rather her you not esteem men settle genius excuse.",
  //     image: Project_image_4
  //   },
  //   {
  //     id: "03",
  //     title: "ROUV",
  //     description: "Continue indulged speaking the was out horrible for domestic position. Seeing rather her you not esteem men settle genius excuse.",
  //     image: Project_image_5
  //   }
  // ];

  return (
    <div className="bg-lightBlue">

<div className="w-full px-4 sm:px-6 md:px-8 lg:px-12 pb-8 pt-8 sm:pt-12 md:pt-20 bg-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          
          {/* Left Column - Images */}
          <div className="relative w-full h-[400px] sm:h-[500px] lg:h-[600px]">
            {/* Red background card */}
            <div 
              className="absolute top-4 left-1/2 -translate-x-1/2 lg:left-10 lg:translate-x-0 
                         w-[280px] sm:w-[400px] h-[400px] sm:h-[500px] 
                         bg-[#61768b] rounded-2xl transform -rotate-6"
            ></div>
            
            {/* Main content card */}
            <div 
              className="relative z-5 w-full h-full flex items-center justify-center animate-float"
            >
              <img 
                src={yourImage}
                alt="Business consultants working" 
                className="rounded-2xl w-[280px] sm:w-[400px] h-[400px] sm:h-[500px] lg:h-[500px] 
                         object-cover shadow-lg"
              />
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="space-y-6 sm:space-y-8 lg:space-y-10 w-full max-w-xl mx-auto pt-2 sm:pt-0">
            <div className="mb-8">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 lg:mb-12 
                           text-center relative group">
                <span className="relative inline-block">
                  Our Industry
                  <span className="absolute bottom-0 left-0 w-full top-9 sm:top-10 lg:top-14 2xl:top-14 4xl:top-14 6xl:top-14 h-1 bg-blue-700 
                                 transform scale-x-0 group-hover:scale-x-100 
                                 transition-transform duration-300"></span>
                </span>
              </h2>
              
              <p className="text-gray-600 text-base sm:text-lg lg:text-lg mb-6 text-center text-justify">
                At Kristellar, we are at the forefront of innovation, combining the realms of 
                aerospace and cyberspace to redefine the boundaries of technological advancement.
              </p>
              
              <hr className="border-gray-300 my-4" />
              
              <p className="text-gray-600 text-base sm:text-lg lg:text-lg text-center text-justify">
                Our mission is to push the limits of human potential, enabling exploration, 
                connectivity, and security in these dynamic domains. Join us as we embark on 
                a journey of discovery and progress. Together, we will shape the future of 
                space exploration with advanced technological innovations and research.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>

    {/* Thought */}
    <section className="relative w-full min-h-[200px] bg-slate-800 py-16">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        {/* Decorative elements */}
        <div className="absolute top-8 left-8 w-24 h-24 opacity-10">
          <svg viewBox="0 0 24 24" fill="white" className="w-full h-full">
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
          </svg>
        </div>
        
        <div className="max-w-5xl mx-auto text-center relative z-5">
          {/* Quote */}
          <blockquote className="mb-4">
            <p className="text-white text-xl md:text-2xl lg:text-lg leading-relaxed font-light italic ">
              "Kristellar Aerospace is a leading aerospace company renowned for its excellence in the industry. With a stellar track record, we specialize in satellite design, integration, and mission support services. Our team of highly skilled professionals combines expertise with innovation to deliver cutting-edge solutions. We are committed to providing exceptional customer service, ensuring prompt and reliable communication at every stage of the project."
            </p>
          </blockquote>
          
          {/* Author details */}
          {/* <div className="flex flex-col items-center">
            <h3 className="text-white text-l font-semibold">Jora'h El Mormont</h3>
            <p className="text-slate-400">Mormont Inc.</p>
          </div> */}
        </div>
      </div>
    </section>  
    
    </div>
  );
};

export default MainContent;
